import * as React from "react";
import { forwardRef } from "react";
const SvgDoneMedium = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11, fill: "currentColor", stroke: "#0F172A", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M6.90039 12.4208L10.8557 16.7925L17.6676 8.07617", stroke: "white", strokeWidth: 2, strokeLinejoin: "bevel" }));
const ForwardRef = forwardRef(SvgDoneMedium);
export { ForwardRef as ReactComponent };
